import echarts from 'echarts'
import merge from 'lodash/merge'

let setAdaption = function (size, setPro, data) {
    if (!setPro) {
        // 默认值
        return 10 * size
    }
    return setPro * size;
};

let colorList =['#40A9FF', ' #26C9C3', '#73D13D', ' #FFC53D', '#FFA940', '#F57582', '#9F69E2', ' #6682F5', '#F273B5'];

export const pieDoubleOption = (setPro, element_id, data) => {
    let chart = echarts.init(document.getElementById(element_id))
    let outerData = []
    let colorIndex = 0
    let innerData = data && data.inner.map(v => {
        colorIndex = colorIndex === data.inner.length ? 0 :  colorIndex;
        v.itemStyle = {
            normal: {
                color: colorList[colorIndex],
            }
        }
        colorIndex++
        return v
    })    
    let outerDatas = data && data.inner.map(v => v.child) //获取所有child
    for (var i = 0; i < outerDatas.length; i++) {
        for (var j = 0; j < outerDatas[i].length; j++) {
            outerDatas[i][j].itemStyle = {
                normal: {
                    color: colorList[i],
                }
            }
            outerData.push(outerDatas[i][j])
        }    
    }
    let legendInner = data && data.inner.map(v => v.name) //内环legend
    // let legendOuter = data.inner.map(v => v.child).map(v => v.name) //外环legend
    // let legend = [...legendInner, ...legendOuter] //全部legend

    // const myOption = {
    //     series: [
    //         {
    //             data: data && innerData
    //         },
    //         {
    //             data: data && outerData
    //         }
    // ]
    // }
    let option = {
        title: {
            show: false,
            text: '我是标题',
            left: 14.08,
            top: "3%",
            textStyle: {
                fontFamily: "MicrosoftYaHei",
                fontSize: setAdaption(1.1, setPro),
                color: "rgba(24, 144, 255, 1)",
                fontWeight: 400,
                lineHeight: 30,
            },
        },
        legend: {
            right: '5%',
            top: 'center',
            orient: 'vertical',
            icon: "circle", //图例图形
            data: legendInner,
            textStyle: {
                fontSize: setAdaption(0.6, setPro),
                color: "rgba(255, 255, 255, 0.65)",
                lineHeight: setAdaption(0.85, setPro)
            },
        },
        //+ params.data.name + params.data.value +
        tooltip: {
            trigger: 'item',
            formatter: (params) => {
                let str = ''
                let str1 = ''
                let str2 = '' 
                let len = params.data.child ?  params.data.child.length : 0
                str1 =`<span style="display:inline-block; width:150px;font-size: 0.7rem">` + params.data.name + '：' + `</span>`+ params.data.value + '%' + '</br>' 
                for (var i = 0; i < len; i ++) {
                    str2 +=  `<span style="display:inline-block;width:12px;height:12px;
                    border-radius:50%;background-color:`+params.color+`;margin-right:5px;"></span>
                    <span style="display:inline-block; width:130px;font-size: 0.65rem">`+ params.data.child[i].name + '：' + `</span>`+ `<span style="font-size:0.6rem;">` + params.data.child[i].value + '%' + `</span>`+ '</br>' 
                }
                str = str1 + str2
                return str
            },
            textStyle: {
                color: "rgba(255, 255, 255, 1)"
            }
        },
        series: [{
                name: '',
                type: 'pie',
                radius: [0, '35%'],
                center: ["35%", "45%"],
                itemStyle: {
                    normal: {
                        borderColor: 'rgba(9, 29, 75, 1)',
                        borderWidth: setAdaption(0.05, setPro),
                        // color: function (params) {
                        //     var colorList = [
                        //         '#40A9FF', ' #26C9C3', '#73D13D', '#FFA940', '#FFC53D', '#9F69E2',
                        //     ]
                        //     return colorList[params.dataIndex]
                        // }
                    }
                },
                label: {
                    normal: {
                        show: false,
                        position: 'inner'
                    }
                },
                labelLine: {
                    normal: {
                        show: false
                    }
                },
                data: innerData
            },
            {
                name: '',
                type: 'pie',
                radius: ['45%', '55%'],
                center: ["35%", "45%"],
                data: outerData,
                // 外环线
                labelLine: {
                    normal: {
                        show: false,
                        length: 20,
                        length2: 40,
                        lineStyle: {
                            color: '#e6e6e6'
                        }
                    }
                },
                itemStyle: {
                    normal: {
                        borderColor: 'rgba(9, 29, 75, 1)',
                        borderWidth: setAdaption(0.05, setPro),
                        // color: function (params) {
                        //     var colorList = [
                        //         '#40A9FF','#40A9FF','#40A9FF', ' #26C9C3', ' #26C9C3', '#73D13D', '#73D13D', '#FFA940', '#FFA940', '#FFC53D', '#FFC53D', '#9F69E2', '#9F69E2'
                        //     ]
                        //     return colorList[params.dataIndex]
                        // }
                    }
                },
                // 外环label数据 
                label: {
                    normal: {
                        show: false, //不显示
                        formatter: params => {
                            return (
                                '{icon|●}{name|' + params.name + '}{percent|'+ params.percent.toFixed(1) +'%}{value|' +
                                (params.value) + '}'
                            );
                        },
                        padding: [0, -130, 25, -130],
                        rich: {
                            color: '#333',
                            icon: {
                                fontSize: 16
                            },
                            name: {
                                fontSize: 14,
                                padding: [0, 5, 0, 5],
                                color: '#666666'
                            },
                            percent: {
                                color: '#333',
                                padding: [0, 5, 0, 0],
                            },
                            value: {
                                fontSize: 16,
                                fontWeight: 'bold',
                                color: '#333333'
                            }
                        }
                    }
                },
            }
        ]
    }

    // const finalSeries = merge(option, myOption)
    // chart.setOption(finalSeries)

    chart.setOption(option)

    // 设置toolTip轮播效果
    let timer = null, index = 0, data_len = option.series[0].data.length;
    function autoTip() {
        // clearInterval(timer)
        timer = setInterval(() => {
            chart.dispatchAction({
                type: 'showTip',
                seriesIndex: 0,
                dataIndex: index
            })
            chart.dispatchAction({
                type: 'downplay',
                seriesIndex: 0,
                dataIndex: index === 0 ? data_len-1 : index-1
            });
            chart.dispatchAction({
                type: 'highlight',
                seriesIndex: 0,
                dataIndex: index
            })
           
            index++;
            if (index >= data_len) {
                index = 0;
            }
        }, 3000)
    }
    let downIndex = []  //记录downplay的索引
    let hignlightIndex = []  //记录highlight的索引
    let index2 = 0, data_len2 = option.series[0].data.length;
    let childIndex = 0  //记录child的索引
    function autoTip1() {
       setInterval(() => {
            let len = outerDatas.length === 0 ? 0 : outerDatas[childIndex].length;
            for (var i = 0; i < len; i++) {
                hignlightIndex.push(index2 + i);
            }
            
            chart.dispatchAction({
                type: 'downplay',
                seriesIndex: 1,
                dataIndex: downIndex
            });
            chart.dispatchAction({
                type: 'highlight',
                seriesIndex: 1,
                dataIndex: hignlightIndex
            })
            childIndex++
            index2 = index2 + i;
            if (childIndex >= data_len2) {
                index2 = 0;
                childIndex = 0;
            }
            downIndex = hignlightIndex
            hignlightIndex = []
            
        }, 3000)
    }
    autoTip()
    autoTip1()

    return chart
}